import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose, DialogTrigger } from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { useAuth } from "@clerk/clerk-react";
import { ClipLoader } from "react-spinners";

export default function DeleteTopic({ topic, onDeleted, triggerButtonProps = {}, }) {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const { getToken } = useAuth()

    const handleDelete = async () => {
        setLoading(true)
        try {
            const token = await getToken()
            if (!token) return
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            }

            await axios.delete(api_endpoint + `/topic/${topic.id}`, reqConfig)
            toast.success(`Topic "${topic.name}" deleted successfully!`)
            setOpen(false)
            onDeleted(topic.id)
        } catch (error) {
            toast.error(`Failed to delete topic "${topic.name}".`)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {/* <span
                className="text-red  hover:underline cursor-pointer"
                onClick={() => setOpen(true)}
            >
                Delete Topic
            </span> */}
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogTrigger asChild>
                    <Button
                        variant="outline"
                        size="sm"
                        className="border-(--color-destructive) text-(--color-destructive) hover:bg-[var(--color-destructive)] hover:text-white"
                        {...triggerButtonProps}
                    >
                        Delete Topic
                    </Button>
                </DialogTrigger>
                <DialogContent className="max-w-md h-auto bg-(--surface-panel) text-(--neutral-900)">
                    <DialogHeader>
                        <DialogTitle className="font-heading text-(--neutral-900)">Delete Topic</DialogTitle>
                    </DialogHeader>
                    <div className="font-body text-(--neutral-700)">
                        Are you sure you want to delete the topic <b>{topic.name}</b>? This action cannot be undone.
                    </div>
                    <DialogFooter>
                        <DialogClose asChild>
                            <Button 
                                variant="outline" 
                                onClick={() => setOpen(false)} 
                                disabled={loading} 
                                className=""
                                >
                                Cancel
                            </Button>
                        </DialogClose>
                        <Button
                            variant=""
                            onClick={handleDelete}
                            disabled={loading}
                            className=""
                        >
                            {loading ? (
                                <span className="flex items-center justify-center w-full">
                                    <ClipLoader size={20} color="var(--neutral-50)" />
                                </span>
                            ) : (
                                "Delete"
                            )}
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    )
}